import { createSlice } from "@reduxjs/toolkit"

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: JSON.parse(localStorage.getItem('user')),
    token: localStorage.getItem('token') == "null" ? null : localStorage.getItem('token'),
    // otherUser: {},
    // otherToken: {},
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload
      state.user = user
      state.token = accessToken
    },
    setUser: (state, action) => {
      state.user = action.payload
    },
    logOut: (state, action) => {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      state.user = null
      state.token = null
    }
  },
})

export const { setCredentials, logOut, setUser } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state) => state.auth.user
export const selectCurrentToken = (state) => state.auth.token